import React, { useState } from "react";
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import RolesList from "./list";

const RoleFormDialog = ({ open,roleName,roleDescription,onClose,onSave,onNameChange,onDescriptionChange,isEdit }) => (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEdit ? "Edit Role" : "Add New Role"}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Role Name"
          fullWidth
          value={roleName}
          onChange={(e) => onNameChange(e.target.value)}
          variant="outlined"
          required
          sx={{ mb: 2, mt: 1 }}
        />
        <TextField
          margin="dense"
          label="Role Description"
          fullWidth
          value={roleDescription}
          onChange={(e) => onDescriptionChange(e.target.value)}
          variant="outlined"
          multiline
          rows={3}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" sx={{
          color: '#0d3559',
          borderColor: '#0d3559',
          '&:hover': {
            borderColor: '#0d3559',
          },
        }}>
          Cancel
        </Button>
        <Button variant="contained" onClick={onSave} disabled={!roleName.trim()}
          sx={{
            backgroundColor: '#0d3559',
            '&:hover': {
              backgroundColor: '#0a2a43',
            },
          }}
        >
          {isEdit ? "Save Changes" : "Add Role"}
        </Button>
      </DialogActions>
    </Dialog>
);

const RolesView = ({
  roles,
  permissions,
  onAddRole,
  onEditRole,
  onDeleteRole,
  onManagePermissions,
  onBack,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [isEditingDialog, setIsEditingDialog] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [roleDescription, setRoleDescription] = useState("");
  const [editingRole, setEditingRole] = useState(null);
  const disabledRoles = ["Super Admin", "Store Admin"];

  const handleAddRoleClick = async () => {
    if (!roleName.trim()) return;
    const res = await onAddRole({
      name: roleName,
      description: roleDescription,
      permissions: {
        dashboard: {
          isEnabled: true,
          permissions: {
            canView: true,
            canEdit: true,
            canCreate: true,
            canDelete: true,
          }
        },
      }
    });
    if (res.success) {
      setOpenDialog(false);
      setRoleName("");
      setRoleDescription("");
    } else {
      alert(res.message || "Role creation failed.");
    }
  };

  const handleEditRoleClick = (role) => {
    setEditingRole(role);
    setRoleName(role.name);
    setRoleDescription(role.description);
    setIsEditingDialog(true);
    setOpenDialog(true);
  };

  const handleSaveEditRoleClick = async () => {
    const res = await onEditRole(editingRole._id, {
      name: roleName,
      description: roleDescription,
    });
    if (res.success) {
      setOpenDialog(false);
      setIsEditingDialog(false);
      setEditingRole(null);
      setRoleName("");
      setRoleDescription("");
    } else {
      alert(res.message || "Role update failed.");
    }
  };

  const handleDeleteRoleClick = async (id) => {
    if (!window.confirm("Delete this role?")) return;
    const res = await onDeleteRole(id);
    if (!res.success) {
      alert(res.message || "Role delete failed.");
    }
  };

  return (
    <Box sx={{ pt: 3 }}>
      <RolesList
        roles={roles}
        onAddRole={() => setOpenDialog(true)}
        onEditRole={handleEditRoleClick}
        onDeleteRole={handleDeleteRoleClick}
        onSelectRole={onManagePermissions}
        disabledRoles={disabledRoles}
        permissions={permissions}
        onBack={onBack}
      />

      <RoleFormDialog
        open={openDialog}
        roleName={roleName}
        roleDescription={roleDescription}
        onClose={() => {
          setOpenDialog(false);
          setIsEditingDialog(false);
          setEditingRole(null);
          setRoleName("");
          setRoleDescription("");
        }}
        onSave={isEditingDialog ? handleSaveEditRoleClick : handleAddRoleClick}
        onNameChange={setRoleName}
        onDescriptionChange={setRoleDescription}
        isEdit={isEditingDialog}
      />
    </Box>
  );
};
export default RolesView;
